import Feedback from './Feedback';
import { IFeedbackMessage } from './Feedback.interface';

export default Feedback;
export { Feedback, IFeedbackMessage };
